/**************************************************
 * Nombre:       Formulario_Tipo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {BadgeOutlined} from "@mui/icons-material";
import {useEffect, useState} from "react";
import {NEGRITA, TIPOSESTUDIANTES} from "../../Constantes";
import IngresoSelectFuncion from "../../Modulo_formularios/Componentes/IngresoSelectFuncion";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";

const Formulario_Tipo = ({...props}) => {
    const [tipo, setTipo] = useState('')
    const [tipos, setTipos] = useState([])

    const cambiar = (e) =>{
        let index = tipos.findIndex((it) => it.nombre ===  e)
        setTipo(tipos[index])
    }

    useEffect(() => {

       let vals = props.props.getValues('valores')
        console.log(vals)
        if (vals && vals.length > 0){
            setTipos(vals)
        }

    },[props.props.watch('valores')])
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Typography sx={{fontSize: 32, fontFamily: NEGRITA, textAlign: 'center', lineHeight: 1.1}}>
                        {props.props.getValues('curso')}
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Typography sx={{fontSize: 16, textAlign: 'center', lineHeight: 1.2}}>
                        {props.props.getValues('justificacion')}
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 16, textAlign: 'center', lineHeight: 1.2}}>
                        Escoge una opcion
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoSelectFuncion Icono={BadgeOutlined} nombre={'Tipo'} dato={'tipo'} {...props}
                                          setDato={cambiar}
                                          opciones={tipos.map((e) => e.nombre)}
                    />
                </Grid>

                {tipo && tipo.nombre &&

                    <>
                        <Grid container size={{xs: 12, sm: 12, md: 12}}>
                            <Typography sx={{fontSize: 20, fontWeight: 600, textAlign: 'center', lineHeight: 1.2}}>
                                {`Valor de Total ${formatoMoneda(tipo.valor)}`}
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}>
                            <Typography sx={{fontSize: 14, fontWeight: 300, textAlign: 'left', lineHeight: 1.2}}>
                                Si eres profesional graduado te pediremos que envies tu titulo, si eres estudiante te
                                pediremos que envies un certificado que acredite esta condicion.
                            </Typography>
                        </Grid>

                    </>


                }


            </Grid>

        </form>

    )

}
export default Formulario_Tipo